export const getDotSize = (size: number) => Math.round((1 / 2.5) * size);
